import React from 'react';

export default function Panel({ children }) {
  return (
    <div className="bg-white overflow-hidden shadow rounded-lg border border-gray-200">
      {children}
    </div>
  );
}
